import identity from 'lodash/fp/identity';
import { select, type Effect, put } from 'redux-saga/effects';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types.tsx';
import { update as updateSequence } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/sequence/actions.tsx';
import {
	FAIL_COMMIT_REQUEST,
	type CommitResponseAction,
	type FailCommitRequestAction,
	type UpdateIssueKeyResponse,
} from '../../issue/types.tsx';
import { json } from '../../http/index.tsx';
import { urls } from '../../issue/api.tsx';
import { POST } from '../../api.tsx';
import { handleCommitResponse, isHandleCommitResponseMethod } from './handleCommitResponse.tsx';

export function* doUpdateIssueKey(
	issueId: string,
	generatedItemId?: string, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Generator<Effect, CommitResponseAction | FailCommitRequestAction, any> {
	const {
		domain: {
			plan: { id: planId, currentScenarioId },
		},
	}: State = yield select(identity);

	const id = generatedItemId ? parseInt(generatedItemId, 10) : null;

	if (id == null || Number.isNaN(id)) {
		// We just return 400 here to save a call
		// The api types allow it but cleary this is invalid and the response will break anyway
		return {
			type: FAIL_COMMIT_REQUEST,
			payload: { ok: false, status: 400, error: 'MANUAL_CREATE_ID_INVALID' },
		};
	}

	const response = yield* json<UpdateIssueKeyResponse>({
		url: urls.updateIssueKey,
		method: POST,
		body: {
			planId,
			scenarioId: currentScenarioId,
			itemKey: issueId,
			generatedItemId,
		},
	});

	if (response.ok && response.data.success) {
		const { change } = response.data;

		yield put(updateSequence(change.sequence));

		if (isHandleCommitResponseMethod(handleCommitResponse)) {
			const finalAction = handleCommitResponse({
				change,
				entity: {},
				id,
			});

			yield put(finalAction);

			return finalAction;
		}
	}

	return {
		type: FAIL_COMMIT_REQUEST,
		payload: response,
	};
}
